const NoResults = () => {
  return (
    <div className='text-muted-foreground text-center text-[14px]'>
      No Results
    </div>
  )
}

export default NoResults
